export enum CounterType {
  Pending = 'pending',
  Recruiting = 'recruiting',
  Ongoing = 'ongoing',
  Archived = 'archived',
}

export interface Counter {
  type: CounterType;
  count: number;
}
